import { Bot, MessageSquare, Smartphone } from 'lucide-react';

/**
 * The glyph for a messaging channel.
 *
 * One map, so the compose cards and the send history cannot draw the same channel
 * two ways. With two channels each site wrote its own `whatsapp ? … : …` ternary;
 * a third channel turned every one of those into a chain that would have to be
 * remembered four times.
 *
 * Lucide carries no brand marks, so these stand in by what the channel IS: a chat
 * app, a phone's text message, a bot. An unknown key falls back to the phone —
 * a history row from a channel this build does not know still gets an icon.
 */
const GLYPH = {
  whatsapp: MessageSquare,
  sms: Smartphone,
  bale: Bot,
};

export default function ChannelIcon({ channel, ...rest }) {
  const Glyph = GLYPH[channel] || Smartphone;
  return <Glyph aria-hidden="true" {...rest} />;
}
